import { graphql } from 'gatsby';
import React, { useEffect } from 'react';
import { Footer } from '../../../doctrine/footer/Footer';
import { BaseHead } from '../components/head/BaseHead';
import { LoggedOutHeader } from '../components/PublicHeader';
import { HomeContainer } from '../components/home/container/HomeContainer';
import { HomeSlices } from '../components/home/HomeSlices';
import { PublicCommon } from '../components/PublicCommon';
import { PageTrackOnLoad } from '../../../doctrine/tracking/PageTrackOnLoad';

interface CustomWindow extends Window {
  page_name?: string;
}

declare let window: CustomWindow;

export const query = graphql`
  {
    prismic {
      allHome_public_v2s {
        edges {
          node {
            page_title
            meta_description
          }
        }
      }
    }
  }
`;

export default ({
  data,
  location,
}: {
  data: Data;
  location: { pathname: string };
}) => {
  const pageName = 'Home';

  useEffect(() => {
    window.page_name = pageName;
  }, []);

  return (
    <PublicCommon>
      <BaseHead
        title={data.prismic.allHome_public_v2s.edges[0].node.page_title}
        url={location.pathname}
        description={
          data.prismic.allHome_public_v2s.edges[0].node.meta_description
        }
      />
      <PageTrackOnLoad pageName={pageName} />
      <LoggedOutHeader pageName={pageName} />
      <HomeContainer>
        <HomeSlices pageName={pageName} />
      </HomeContainer>
      <Footer />
    </PublicCommon>
  );
};

type Data = {
  prismic: {
    allHome_public_v2s: {
      edges: Array<{
        node: {
          page_title?: string;
          meta_description?: string;
        };
      }>;
    };
  };
};
